<footer class="rpt-footer noprint">
  <div class="rpt-wrap rpt-footer__inner">
    <div class="rpt-footer__meta">Report generated {{today | date:'d MMM yyyy'}} · Adventum Capital</div>
    <div style="display:flex;gap:8px;flex-wrap:wrap;">
      <button *ngIf="!loadingShare" class="rpt-btn" (click)="openModal()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
        Share
      </button>
      <button *ngIf="loadingShare" class="rpt-btn"><i class="fa fa-spin fa-spinner"></i></button>
      <button class="rpt-btn rpt-btn--primary" (click)="recalculate.emit()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>
        Recalculate
      </button>
      <button *ngIf="!loadingDownload" class="rpt-btn rpt-btn--accent" (click)="download.emit()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
        Download PDF
      </button>
      <button *ngIf="loadingDownload" class="rpt-btn rpt-btn--accent"><i class="fa fa-spin fa-spinner"></i></button>
    </div>
  </div>
</footer>

<div class="modal fade noprint rpt-modal" id="rptShareModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5>Share Report</h5>
      </div>
      <div class="modal-body">
        <label>Enter email IDs of recipients</label>
        <input type="email" placeholder="e.g. joe@gmail.com, mark@gmail.com"
          [(ngModel)]="email" autocomplete="off">
      </div>
      <div class="modal-footer">
        <button class="rpt-modal__cancel" (click)="closeModal()" [disabled]="loadingShare">Cancel</button>
        <button *ngIf="loadingShare" class="rpt-modal__send"><i class="fa fa-spin fa-spinner"></i> Sending...</button>
        <button *ngIf="!loadingShare" class="rpt-modal__send" (click)="onSend()">Send</button>
      </div>
    </div>
  </div>
</div>
